/**
 * The 8 weekly-action check families from the outcome-first SEO plan.
 *
 * Some checks emit the class `id` as `checkId` (e.g. `broken_links`);
 * others emit subtype IDs (HTTPS/HSTS, sitemap coverage). Include both
 * parents and emitted subtypes so filters never silently drop real findings.
 */
export const DEFAULT_ACTIONABLE_CHECKS: readonly string[] = [
  // 1. Broken links
  'broken_links',
  // 2. Missing meta descriptions
  'missing_meta_description',
  // 3. Duplicate titles
  'dup_titles',
  // 4. Thin content
  'thin_content',
  // 5. Core Web Vitals
  'core_web_vitals',
  // 6. HTTPS / HSTS (class id + subtypes actually stored on issues)
  'https_hsts',
  'https_not_enforced',
  'hsts_missing',
  // 7. Multiple H1 / heading hierarchy
  'multiple_h1',
  'heading_hierarchy_skipped',
  // 8. Sitemap + canonical (class ids + sitemap subtypes)
  'sitemap_coverage',
  'sitemap_urls_not_crawlable',
  'crawled_urls_not_in_sitemap',
  'canonical_missing',
  'canonical_conflict',
];

const ACTIONABLE_SET = new Set<string>(DEFAULT_ACTIONABLE_CHECKS);

export function isActionableCheck(checkId: string): boolean {
  return ACTIONABLE_SET.has(checkId);
}
